export function caseStudySlider() {
    const $slider = $(".case-study-slider");
    const $sliderCounter = $(".case-study-counter");
    const $sliderCounterCurrent = $sliderCounter.find(".current");
    const $sliderCounterNumber = $sliderCounter.find(".number");
    let count = $(".case-study-item").length;

    if (count < 10) {
        $sliderCounterNumber.text("0" + count);
    } else {
        $sliderCounterNumber.text(count);
    }
    $slider.slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 600,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    variableWidth: true,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true
                }
            }
        ],
        prevArrow: "<button type='button' class='slick-prev'><svg width=\"29\" height=\"11\" viewBox=\"0 0 29 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M29 10L2 10L8.66959 1\" stroke=\"black\" stroke-width=\"2\"/>\n" +
            "</svg></button>",
        nextArrow: "<button type='button' class='slick-next'><svg width=\"29\" height=\"11\" viewBox=\"0 0 29 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M0 10L27 10L20.3304 1\" stroke=\"black\" stroke-width=\"2\"/>\n" +
            "</svg>\n</button>"
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $sliderCounterCurrent.text(nextSlide + 1);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/caseStudySlider.js